import { useOnOutsideClick } from "client/hooks/utils/useOnOutsideClick";
import { useToggle } from "client/hooks/utils/useToggle";
import { useRef, useState } from "react";
import { isColorActive } from "store/features/memeGenerator/isColorActive";
import { useColorList } from "../useColorList";
import type { ColorChangeHandler } from "react-color";
import type { TextBox } from "store/features/memeGenerator/types";
import type { Mode } from "../../types";

export const useColorPickerButton = (textBox: TextBox, mode: Mode) => {
    const { isOpen, onClose: close, toggle } = useToggle();
    const parentRef = useRef<HTMLButtonElement>(null);
    useOnOutsideClick(parentRef, isOpen, close);
    const [color, setColor] = useState("");
    const { onColorChoose: handleColorChange } = useColorList(textBox, mode);
    const onChange: ColorChangeHandler = (color) => {
        const value = color.hex;
        setColor(value);
        handleColorChange(value);
    };
    const isActive = isColorActive(color, textBox, mode);
    return {
        isOpen,
        isActive,
        toggle,
        parentRef,
        color,
        onChange,
        handleColorChange,
    };
};
